import React from "react";
import { Tag } from "antd";
import { arrComparer, removeDupes } from "../../../../api/util";
import { fetchJsData } from "../../../../api";
import { isArray } from "lodash";

export const newApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "app_name",
      key: "app_name",
      fixed: "left",
      sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
      // responsive: ["sm"],
      width: "25%",
    },
    {
      title: "Domains",
      dataIndex: "domains",
      key: "domains",
      fixed: "left",
      // responsive: ["sm"],
      width: "25%",
      ellipsis: true,
      render: (text) => {
        return <>{isArray(text) ? text.join(", ") : text}</>;
      },
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      // responsive: ["sm"],
      width: "20%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      // responsive: ["sm"],
      width: "20%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "10%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };

// const arr = data["data"].reduce((acc, item) => {
//   const found = acc.find((i) => i.current_name === item.current_name);

//   if (found) {
//     found.names.push(item.names);
//   } else {
//     acc.push({
//       current_name: item.current_name,
//       old_category: item.old_category,
//       new_category: item.new_category,
//       customtag: item.customtag,
//       domain_name: [item.domain_name],
//     });
//   }

//   return acc;
// }, []);
